interface Stars {
  (): {
    getStars: (rating: unknown) => number;
  };
}

/**
 * Rating del hotel (1 a 5) tal como lo manda BookingV2: el del catálogo de
 * booking-internal (el del hotel o, si no tiene, el de su marca), o `null` si no
 * tiene. Ya no llegan códigos de proveedor que traducir; aquí sólo se acota a 1-5
 * y cualquier otra cosa cuenta como «Sin rating» (0).
 */
export const useStars: Stars = () => {
  const getStars = (rating: unknown) => {
    const n = Number(rating);

    return Number.isInteger(n) && n >= 1 && n <= 5 ? n : 0;
  };

  return {
    getStars,
  };
};
